export const makeRoutes = <T>(routes: T): T => routes;
